<template>
    <div>
        <div class="row">
            <div class="col-lg-6 mb-50">
                <label class="form-label">İşyeri Kodu</label>
                <input class="form-control" type="text" v-model="value.ISYERI" placeholder="İşyeri Kodu"/>
            </div>
            <div class="col-lg-6 mb-50">
                <label class="form-label">Unvan</label>
                <input class="form-control" type="text" v-model="value.UNVAN" placeholder="Unvan"/>
            </div>
            <div class="col-lg-6 mb-50">
                <label class="form-label">Kuruluş Tarihi</label>
                <v-date-picker placeholder="Kuruluş Tarihi" v-model="value.KURULUSTAR"></v-date-picker>
            </div>
            <div class="col-lg-6 mb-50">
                <label class="form-label">Ticaret Sicil Numarası</label>
                <input class="form-control" type="text" v-model="value.TICARETSICNO" placeholder="Ticaret Sicil Numarası"/>
            </div>
            <div class="col-lg-6 mb-50">
                <label class="form-label">İŞKUR Birimi</label>
                <input class="form-control" type="text" v-model="value.ISKURBIRIMI" placeholder="İŞKUR Birimi"/>
            </div>
            <div class="col-lg-6 mb-50">
                <label class="form-label">İŞKUR Dosya Numarası</label>
                <input class="form-control" type="text" v-model="value.ISKURDOSYANO" placeholder="İŞKUR Dosya Numarası"/>
            </div>
            <div class="col-lg-6 mb-50">
                <!--TODO SELECT BOX-->
                <label class="form-label">İşyeri Türü</label>
                <input class="form-control" type="text" v-model="value.ISYERI_TURU" placeholder="İşyeri Türü"/>
            </div>
            <div class="col-lg-6 mb-50">
                <label class="form-label">İşyeri/Şube Kodu</label>
                <input class="form-control" type="text" v-model="value.ISYERI_SUBE_KODU" placeholder="İşyeri/Şube Kodu"/>
            </div>
            <div class="col-lg-6 mb-50">
                <label class="form-label">İşyeri/Şube Adres No</label>
                <input class="form-control" type="text" v-model="value.ISYERI_ADRES_NO" placeholder="İşyeri/Şube Adres No"/>
            </div>
            <div class="col-lg-6 mb-50">
                <!--TODO SELECT BOX-->
                <label class="form-label">Ticaret Sicil Müdürlüğü</label>
                <input class="form-control" type="text" v-model="value.TIC_SIC_MUD" placeholder="Ticaret Sicil Müdürlüğü"/>
            </div>
            <div class="col-lg-6 mb-1 mb-lg-0">
                <label class="form-label">İşyeri/Şube Faaliyet (NACE) Kodu</label>
                <input class="form-control" type="text" v-model="value.NACE_KODU" placeholder="İşyeri/Şube Faaliyet (NACE) Kodu"/>
            </div>
            <div class="col-lg-6">
                <!--TODO SELECT BOX-->
                <label class="form-label">İşyeri/Şube Mülkiyet Durumu</label>
                <input class="form-control" type="text" v-model="value.MULKIYET_DURUMU" placeholder="İşyeri/Şube Mülkiyet Durumu"/>
            </div>
        </div>
        <hr/>
        <div class="row">
            <div class="col-lg-6">
                <div class="row">
                    <div class="col-lg-4 mb-50">
                        <label class="form-label">Sektör</label>
                        <input class="form-control" type="text" v-model="value.SSK_SEKTOR" placeholder="Sektör"/>
                    </div>
                    <div class="col-lg-4 mb-50">
                        <label class="form-label">Meslek</label>
                        <input class="form-control" type="text" v-model="value.SSK_MESLEK" placeholder="Meslek"/>
                    </div>
                    <div class="col-lg-4 mb-50">
                        <label class="form-label">Şube</label>
                        <input class="form-control" type="text" v-model="value.SSK_SUBE" placeholder="Şube"/>
                    </div>
                    <div class="col-12 mb-50">
                        <label class="form-label">Dosya</label>
                        <input class="form-control" type="text" v-model="value.SSK_DOSYANO" placeholder="Dosya"/>
                    </div>
                    <div class="col-lg-4 mb-50">
                        <label class="form-label">İl</label>
                        <input class="form-control" type="text" v-model="value.SSK_IL" placeholder="İl"/>
                    </div>
                    <div class="col-lg-4 mb-50">
                        <label class="form-label">İlçe</label>
                        <input class="form-control" type="text" v-model="value.SSK_ILCE" placeholder="İlçe"/>
                    </div>
                    <div class="col-lg-4 mb-50">
                        <label class="form-label">Kont K.</label>
                        <input class="form-control" type="text" placeholder="Kont K." v-model="value.SSK_NO"/>
                    </div>
                </div>
            </div>
            <div class="col-lg-6">
                <div class="row">
                    <div class="col-12 mb-50">
                        <label class="form-label">Vergi Dairesi</label>
                        <input class="form-control" type="text" v-model="value.V_DAIRE" placeholder="Vergi Dairesi"/>
                    </div>
                    <div class="col-12 mb-50">
                        <label class="form-label">Vergi Hesap Numarası</label>
                        <input class="form-control" type="text" v-model="value.V_HESAPNO" placeholder="Vergi Hesap Numarası"/>
                    </div>
                    <div class="col-12 mb-50">
                        <label class="form-label">Yapılan İş</label>
                        <input class="form-control" type="text" v-model="value.YAPILAN_IS" placeholder="Yapılan İş"/>
                    </div>
                </div>
            </div>
            <div class="col-lg-6">
                <div class="row">
                    <div class="col-lg-8 mb-50">
                        <label class="form-label">Bölge Çalışma Numarası</label>
                        <input class="form-control" type="text" v-model="value.BOLGE_SSK" placeholder="Bölge Çalışma Numarası"/>
                    </div>
                    <div class="col-lg-4 mb-50">
                        <label class="form-label">İş Kodu</label>
                        <input class="form-control" type="text" v-model="value.ISKODU" placeholder="İş Kodu"/>
                    </div>
                </div>
            </div>
            <div class="col-lg-6 mb-50">
                <label class="form-label">Şube Adı</label>
                <input class="form-control" type="text" v-model="value.SSK_SUBE_ADI" placeholder="Şube Adı"/>
            </div>
            <div class="col-12 mb-50">
                <!--TODO SELECT BOX-->
                <label class="form-label">Vergi Dairesi Kodu</label>
                <input class="form-control" type="text" v-model="value.VD_KODU" placeholder="Vergi Dairesi Kodu"/>
            </div>
            <div class="col-12">
                <label class="form-label">İşletme Merkezi</label>
                <input class="form-control" type="text" v-model="value.ISYERIMERKEZI" placeholder="İşletme Merkezi"/>
            </div>
        </div>
        <hr/>
        <div class="row">
            <div class="col-lg-6 mb-50">
                <label class="form-label">Banka Şubesi</label>
                <input class="form-control" type="text" v-model="value.BANKASUBE" placeholder="Banka Şubesi"/>
            </div>
            <div class="col-lg-6 mb-50">
                <label class="form-label">Banka Hesap Numarası</label>
                <input class="form-control" type="text" v-model="value.BANKAHESAP" placeholder="Banka Hesap Numarası"/>
            </div>
            <div class="col-lg-6 mb-50">
                <label class="form-label">Tehlike Sınıfı</label>
                <input class="form-control" type="text" v-model="value.SINIF" placeholder="Tehlike Sınıfı"/>
            </div>
            <div class="col-lg-6 mb-50">
                <label class="form-label">Kısa Vad. Sig. Kol. Primi</label>
                <input class="form-control" type="text" v-model="value.TEH_ORANI" placeholder="Kısa Vad. Sig. Kol. Primi"/>
            </div>
            <div class="col-lg-6 mb-50 mb-lg-0">
                <label class="form-label">Tehlike Derecesi</label>
                <div>
                    <b-form-radio inline value="N" v-model="value.TEHLIKE">Normal</b-form-radio>
                    <b-form-radio inline value="A" v-model="value.TEHLIKE">Alt</b-form-radio>
                    <b-form-radio inline value="U" v-model="value.TEHLIKE">Üst</b-form-radio>
                </div>
            </div>
            <div class="col-lg-6">
                <!-- TODO VALUE -->
                <label class="form-label">SGK İş. Sınıf/Oran</label>
                <div>
                    <b-form-radio inline value="S" v-model="value.SINIF_ORAN">Sınıf</b-form-radio>
                    <b-form-radio inline value="X" v-model="value.SINIF_ORAN">Oran</b-form-radio>
                </div>
            </div>
        </div>
        <hr/>
        <div class="row">
            <div class="col-lg-6 mb-50">
                <label class="form-label">Taşeron</label>
                <input class="form-control" v-model="value.TASERON" type="text" placeholder="Taşeron"/>
            </div>
            <div class="col-lg-6 mb-50">
                <label class="form-label">Yuvarlama Bazı</label>
                <input class="form-control" type="number" v-model="value.YUVARLAMABAZI" placeholder="Yuvarlama Bazı"/>
            </div>
            <div class="col-lg-6 mb-50">
                <label class="form-label">Hesap Kodu</label>
                <input class="form-control" type="text" v-model="value.DEFHESAP" placeholder="Hesap Kodu"/>
            </div>
            <div class="col-lg-6 mb-lg-50 mb-0">
                <label class="form-label">Günlük/Aylık Çalışma Saati</label>
                <input class="form-control" type="text" v-model="value.GUNLUK_SAAT" placeholder="Günlük/Aylık Çalışma Saati"/>
            </div>
        </div>
        <hr/>
        <div class="row">
            <div class="col-lg-6 mb-50">
                <label class="form-label">Maden Malulluk Oranı İşveren</label>
                <input class="form-control" type="text" v-model="value.MADENMALULORAN" placeholder="Maden Malulluk Oranı İşveren"/>
            </div>
            <div class="col-lg-6 mb-50">
                <label class="form-label">Maden İş Kazaları Oranı</label>
                <input class="form-control" type="text" v-model="value.MADENISKAZAORAN" placeholder="Maden İş Kazaları Oranı"/>
            </div>
            <div class="col-lg-6 mb-50">
                <label class="form-label">Malulluk Oranı İşveren</label>
                <input class="form-control" type="text" v-model="value.MALULORAN" placeholder="Malulluk Oranı İşveren"/>
            </div>
            <div class="col-lg-6 mb-50">
                <label class="form-label">İşyeri Mersis Numarası</label>
                <input class="form-control" type="text" v-model="value.MERSISNO" placeholder="İşyeri Mersis Numarası"/>
            </div>
            <div class="col-lg-6 mb-50 mb-lg-0">
                <label class="form-label">İşveren İşsiz Sigorta İndirim Oranı (%)</label>
                <input class="form-control" type="text" v-model="value.SSK_ISZ_ISVR_TESVIK_ORANI" placeholder="İşveren İşsiz Sigorta İndirim Oranı (%)"/>
            </div>
            <div class="col-lg-6 mb-50 mb-lg-0">
                <!-- TODO VALUE -->
                <label class="form-label">İş Yerinin Bulunduğu Bölge</label>
                <div>
                    <b-form-radio inline value="X" v-model="value.BOLGE">Org. San. ve End. Böl.</b-form-radio>
                    <b-form-radio inline value="Y" v-model="value.BOLGE">Diğer</b-form-radio>
                </div>
            </div>
        </div>
        <hr/>
        <div class="row">
            <div class="col-12"> 
                <div class="border rounded p-75">
                    <h5 class="mb-0 font-weight-bolder">Kanun 5921 Ek Madde 2</h5>
                    <div class="row">
                        <div class="col-lg-6 mb-50 mb-lg-0">
                            <label class="form-label">Prim Teşvik Tutarı</label>
                            <input class="form-control" type="text" placeholder="Prim Teşvik Tutarı"/>
                        </div>
                        <div class="col-lg-6">
                            <label class="form-label">Yararlanılan Teşvik Tutarı</label>
                            <input class="form-control" disabled type="text" placeholder="Yararlanılan Teşvik Tutarı"/>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <hr/>
        <div class="row">
            <div class="col-lg-6 mb-50 mb-lg-0">
                <div class="border rounded p-75">
                    <h5 class="mb-0 font-weight-bolder">Kanun 7166 Madde 8</h5>
                    <div class="row">
                        <div class="col-12">
                            <label class="form-label">Günlük Tutarı</label>
                            <input class="form-control" v-model="value.K7166M8GUNTUTAR" type="number" placeholder="Günlük Tutarı"/>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-lg-6">
                <div class="border rounded p-75">
                    <h5 class="mb-0 font-weight-bolder">Kanun 7256</h5>
                    <div class="row">
                        <div class="col-12">
                            <label class="form-label">Günlük Tutarı</label>
                            <input class="form-control" v-model="value.K7256M28GUNTUTAR" type="number" placeholder="Günlük Tutarı"/>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <hr/>
        <div class="row">
            <div class="col-lg-6 mb-50">
                <label class="form-label">Şirket E-Posta</label>
                <input class="form-control" v-model="value.EPOSTA" type="text" placeholder="Şirket E-Posta"/>
            </div>
            <div class="col-lg-6 mb-50">
                <label class="form-label">Şirket Web Adresi</label>
                <input class="form-control" type="text" v-model="value.WEB" placeholder="Şirket Web Adresi"/>
            </div>
            <div class="col-lg-6">
                <label class="form-label">Şirket Faksı</label>
                <input class="form-control" type="text" v-model="value.FAX" placeholder="Şirket Faksı"/>
            </div>
        </div>
    </div>
</template>

<script>
import { BFormCheckbox, BFormRadio } from 'bootstrap-vue'
export default {
    props:{
        value:Object
    },
    components:{
        BFormCheckbox,
        BFormRadio
    }
}
</script>

<style>

</style>